import {lazy, FC, Suspense, useEffect} from 'react';
import {Route, Routes, Navigate} from 'react-router-dom';
import {MasterLayout} from '../../_metronic/layout/MasterLayout';
import TopBarProgress from 'react-topbar-progress-indicator';
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper';
import {MenuTestPage} from '../pages/MenuTestPage';
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils';
import {WithChildren} from '../../_metronic/helpers';
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper';

import {AsideMenuMain} from 'src/_metronic/layout/components/aside/AsideMenuMain';
import {AsideMenuMain as AsideMenuSystems} from 'src/_metronic/layout/components/aside/AsideMenuSystems';
import AccountPage from '../pages/account/AccountPage';
import {useDispatch, useSelector} from 'react-redux';
import * as authHelper from 'src/app/modules/auth/core/AuthHelpers';
import * as actionsGlobal from 'src/setup/redux/global/Actions';

const PrivateRoutes = () => {
  const SystemsPage = lazy(() => import('../pages/systems/SystemsPage'));

  return (
    <Routes>
      <Route path='account' element={<AccountPage />} />
      {/* <Route path='auth/*' element={<Navigate to='/systems' />} /> */}

      <Route path='systems/*' element={<MasterLayout asideMenu={<AsideMenuSystems />} />}>
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='*'
          element={
            <SuspensedView>
              <SystemsPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
      </Route>

      <Route path='*' element={<Navigate to='/systems' />} />
    </Routes>
  );
};

const SuspensedView = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary');
  TopBarProgress.config({
    barColors: {
      0: baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export {PrivateRoutes};
